import { ConfigService } from './../../../services/config.service';
import { TranslationService } from 'app/services/translation.service';
import { AfterViewInit, Component, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { TaskService } from '../../../services/task.service';
import { ModalType, Statuses, Task, TaskLevel } from '../../../entities/Task'
import { GantChart } from '../../../entities/GantChart';
import { ConverterService, FilterMapping } from '../../../services/converter.service';
import { ActivatedRoute } from '@angular/router';
import { Job } from '../../../entities/Job';
import * as moment from 'moment';
import { environment, productModels } from '../../../../environments/environment';
import { FilterTypes, TaskPageModel } from '../../../entities/PageModel';
import { Observable } from 'rxjs/Observable';
import { SessionService } from '../../../services/session.service';
import { UIConfigSessionObject } from '../../../entities/UIConfigSessionObject';
import { DateRangeFilter, FilterModel } from '../../../entities/FilterModel';
import { EplannerTasksWithFilterService } from '../../../services/eplanner-tasks-with-filter.service';
import { AppConfig } from '../../../app.config';
import { EmployeeService } from '../../../services/employee.service';
import { NotificationService } from '../../../services/notification.service';
import { AppTaskCategory } from '../../../entities/AppTaskCategory';
import { LoginService } from '../../../services/login.service';
import { TaskActivity } from '../../../entities/TaskActivity';
import { TaskActivityService } from '../../../services/task-activity.service';
import { ExternalFilterField } from '../../../entities/ExternalFilterField';
import { ExternalFilter } from '../../../entities/ExternalFilter';
import { Subscription } from 'rxjs/Subscription';
import { DatePickerModel } from '../../../entities/DatePickerModel';
import { SalesPersonService } from '../../../services/sales-person.service';
import { Responsible } from '../../../entities/SalesPerson';
import { Translation } from 'app/entities/Translation';
import { RouteService } from 'app/services/route.service';
import { MaintenanceNotification } from 'app/entities/MaintenanceNotification';

declare var $: any;

@Component({
  selector: 'app-gant-chart',
  templateUrl: './gant-chart.component.html',
  styleUrls: ['./gant-chart.component.css']
})
export class GantChartComponent implements OnInit, OnDestroy, AfterViewInit {

  public externalFilter: ExternalFilter;
  ModalTypes = ModalType;
  ChosenModal: string;
  validateStyles: boolean;
  screenHeight: number;
  dateRangeFilters = DateRangeFilter;
  dateRangekeys = Object.keys(this.dateRangeFilters).filter(k => !isNaN(Number(k)))
  loggedInSalesperson: Responsible;
  public stringFilter: string
  public gantChart: GantChart = null;
  public subscription;
  public jobSubscription;
  public ChosenJob: Job;
  public maxResourceNameLength: number = 1;
  public maxResourceCodeLength: number = 1;
  public firstRun: boolean = true;
  public showDatesOnResource = false;
  public responsibles: Responsible[] = [];
  public chosenResponsible: Responsible;
  public chosenStatus: string;
  public duration = 7;
  public AppTaskCategories: AppTaskCategory[];
  public chosenCategory: AppTaskCategory;
  public productModels = productModels;
  public currentProductModel: any;
  public loggedInUserNo: string;
  isGantChart: boolean;
  yearSlotWidth = 3;
  showCalendar = false;
  jobsTaskToggled = false;
  dateChanged: boolean;
  public loading = false;
  isInitialized: boolean
  public taskStatuses = Statuses;
    public keys: string[];
  chosenTask: Task;
  public listToShow = '1a';
  isDragging = false;
  public currentLanguage: string
  currentView = 'yearTimeline'
  taskLevels = TaskLevel;
  currentTaskLevel: string;
  createIsDisabledAndTrue: boolean;
  isOTSTaskShown: boolean = false;
  isOTSCheckboxDisabled: boolean = false;
  combinedFilterValues: Map<string, string> = new Map<string, string>();
  loadingSaveButton = false;
  translationsLoaded: boolean = false;

  // Specific for TaskOverView
  companies: any[];
  salespersons: Responsible[];
  //maintenanceObjectDTO: MaintenanceObject_DTO;
  tasks: Task[];

  /** Date navigation **/
  datePickerModel: DatePickerModel = {};

  @ViewChild('dumbComp') child;
  private externalSub: Subscription;
  private allTasksSub: Subscription;
  private placedSub: Subscription;
  countByFilterProp; // An object that contains a count of selected filters so they can be displayed as a number in the filter dropdowns
  translations: Map<string, Translation>;
  private readonly mobileBreakpoint = 767;
  showMobileFilters = false;
  private isMobileLayout = false;
  private lockedBodyOverflow = '';
  private lockedHtmlOverflow = '';
  private pageScrollLocked = false;


  public get isSelectedCompanyOTS() {
    return this.sessionService.getCompanyType() === TaskLevel.OTS;
  }

  constructor(private taskservice: TaskService,
    private eplannerTasksWithFilterService: EplannerTasksWithFilterService,
    public convertservice: ConverterService,
    private route: ActivatedRoute,
    private config: ConfigService,
    private salesPersonService: SalesPersonService,
    private sessionService: SessionService,
    private appConfig: AppConfig,
    private employeeService: EmployeeService,
    private notificationService: NotificationService,
    private loginService: LoginService,
    private activityService: TaskActivityService,
    private translationService: TranslationService,
    private routeService: RouteService,
    ) {
  }

  ngOnInit() {
    this.initGeneralForViews();
    this.GetAppTaskCategories();

    // sets the internal state so initial state doesnt show ots tasks if you are not logged in as ots
    
    if (this.isSelectedCompanyOTS) {
      this.isOTSTaskShown = true;
      this.isOTSCheckboxDisabled = true;
    }
    this.setTranslations();

    const activeLanguageSub = this.translationService.getLanguageSubject().subscribe(language => {
      this.currentLanguage = language;
     }, () => {}, () => {activeLanguageSub.unsubscribe()})
  
  }

  ngAfterViewInit() {
    this.applyPanelLayout();

    window.addEventListener('resize', () => {
      this.applyPanelLayout();
    });
  }

  private applyPanelLayout() {
    this.screenHeight = $(window).height();
    const isMobile = window.innerWidth <= this.mobileBreakpoint;
    this.setPageScrollLock(this.currentProductModel === productModels.Maintenance);
    if (isMobile !== this.isMobileLayout) {
      this.isMobileLayout = isMobile;
      this.showMobileFilters = false;
    }

    if (isMobile) {
      $('#first-panel-default').css('min-height', '0');
      $('#first-panel-default').css('height', 'auto');
      $('#first-panel-body').css('height', 'auto');
      $('#first-panel-body').css('min-height', '0');
      return;
    }

    $('#first-panel-default').css('min-height', this.screenHeight - 100);
    $('#first-panel-default').css('height', this.screenHeight - 100);
    $('#first-panel-body').css('min-height', 0);
    $('#first-panel-body').height(this.screenHeight - 200);
  }

  isMobileView(): boolean {
    return window.innerWidth <= this.mobileBreakpoint;
  }

  toggleMobileFilters() {
    this.showMobileFilters = !this.showMobileFilters;
  }

  initGeneralForViews() {
    this.isGantChart = true;
    this.currentProductModel = this.appConfig.getConfig('productModel');
    this.keys = Object.keys(this.taskStatuses).filter(k => !isNaN(Number(k)));
    this.loggedInUserNo = this.loginService.getLoggedInUserID();
    this.externalFilter = { SalesPersonCode: '', IsAscending: false, SortField: null, ViewName: '', FilterFields: [] };
    // reset cookie
    const salesPersonSub = this.salesPersonService.getSalesPerson().subscribe(salesperson => {
      this.responsibles = salesperson;
      this.loggedInSalesperson = salesperson.find(sp => sp.Code.toUpperCase() === this.sessionService.getUserNo().toUpperCase())
      if (this.loggedInSalesperson !== undefined) {
        this.setExternalFilterFields();
        // set show ots tasks to false if logged in company isnt OTS
        if(!this.isSelectedCompanyOTS){
          this.initShowOTS();
        }
        this.refreshView();
      }
      this.sessionService.setUIConfigSession(new UIConfigSessionObject());
      if (this.currentProductModel === productModels.Premium && this.isGantChart) {
        this.refreshView()
      } else if (this.currentProductModel === productModels.Maintenance) {
        this.setChosenJob();
        this.SetDateRangeFromJobFunction(this.ChosenJob);
      }

      this.jobSubscription = this.config.observableJob.subscribe(x => {
        if (!this.firstRun) {
          // reset cookie
          this.sessionService.setUIConfigSession(new UIConfigSessionObject());
          this.refreshView()
        } else {
          this.firstRun = false;
        }
      });
    }, error => { }, () => {
      salesPersonSub.unsubscribe()
    })

    this.loggedInUserNo = this.loginService.getLoggedInUserID();

    const loginSub = this.loginService.getCompanies().subscribe(companies => {
      this.companies = companies;
    }, error => {
    }, () => {
      loginSub.unsubscribe()
    })
  }

  /**
   * The function initializes the external filter and sets the isOTSTaskShown variable to false.
   */
  initShowOTS(){
    if (this.externalFilter.FilterFields.length === 0){
      this.externalFilter.FilterFields.push({SalesPerson_Code: '', View_Name: '', Field_Name: 'TASKLEVEL', Field_Value: 'INTERN'});
      this.isOTSTaskShown = false; 
    }
  }

  OpenCreateNotificationModal() {
    this.ChosenModal = ModalType.CreateNotificationModal;
    setTimeout(() => {
      $('#createNotificationModal').modal('show');
    }, 5)
  }

  SetDateRangeFromJobFunction(job: any) {

    if (job != null) {

      if (job != this.ChosenJob) {
        this.dateChanged = true;
      }

      this.currentView = 'dateRangeTimeLine';
      this.currentProductModel = this.appConfig.getConfig('productModel');

      if (this.currentProductModel === productModels.Premium) {
        let s = new Date(job.start);
        s.setDate(s.getDate() - 3);
        this.datePickerModel.StartDate = s;
        let e = new Date(job.end);
        e.setDate(e.getDate() + 3);
        this.datePickerModel.EndDate = e;
      } else if (this.currentProductModel === productModels.Maintenance) {
        // Sets date from previous monday, and 2 week forward.  >>
        const startDate = this.setStartToMonday();

        this.datePickerModel.StartDate = new Date(startDate);
        this.datePickerModel.StartDate.setHours(0);
        this.datePickerModel.StartDate.setMinutes(0);
        this.datePickerModel.StartDate.setSeconds(0);

        // let diff2 = startDate.getDate() + 13;
        const diff2 = this.datePickerModel.StartDate.getDate() + this.getDateRangeFilter(this.dateRangeFilters[this.loggedInSalesperson.Date_Period_Setup], this.datePickerModel.StartDate)
        this.datePickerModel.EndDate = new Date(startDate.setDate(diff2));
        this.datePickerModel.EndDate.setHours(0);
        this.datePickerModel.EndDate.setMinutes(0);
        this.datePickerModel.EndDate.setSeconds(0);
      }
      this.setOptionsData();
      // Maintenance
      if (this.currentProductModel === productModels.Maintenance) {
        this.refreshView(new FilterModel(moment(this.datePickerModel.StartDate).format(environment.FULL_DATETIME_FORMAT), moment(this.datePickerModel.EndDate).format(environment.FULL_DATETIME_FORMAT)));
      }
    }
  }

  // Start
  toggleJobTasks() {
    this.showCalendar = false;
    this.jobsTaskToggled = !this.jobsTaskToggled;

    if (this.jobsTaskToggled) {
      this.yearSlotWidth = 3;
    } else {
      this.yearSlotWidth = 4;
    }

    this.child.rerenderCalendar(this.gantChart);
    this.showCalendar = true;
  }

  setStartToMonday(): Date {
    let monday: Date
    if (moment().day() !== 1) {
      monday = moment().day(1).toDate();
    } else {
      monday = moment().toDate();
    }
    return new Date(monday);
  }

  /**
   * Sets the date to the week day of the day parameter.
   * E.g. 0 would be Sunday.
   *      1 Monday
   * @param date The date to get the specified day of.
   * @param day The day to get of the date.
   * @returns A date set to the specified date.
   */
  setDateToDay(date: Date, day: number): Date {
    let momentDate = moment(date);

    if (momentDate.day() !== day) {
      date = momentDate.day(day).toDate();
    } else {
      date = momentDate.toDate();
    }
    return new Date(date);
  }

  setEndDate(event: any) {
    $('.btn-with-tooltip').blur();
    event.jsdate ? this.datePickerModel.EndDate = event.jsdate : this.datePickerModel.EndDate = event;

    this.dateChanged = true;
    this.setOptionsData();

    // Maintenance
    if (this.currentProductModel === productModels.Premium) {
      this.child.rerenderCalendar(this.gantChart, true);
    } else if (this.currentProductModel === productModels.Maintenance) {
      this.refreshView(new FilterModel(moment(this.datePickerModel.StartDate)
        .format(environment.FULL_DATETIME_FORMAT), moment(this.datePickerModel.EndDate)
          .format(environment.FULL_DATETIME_FORMAT)));
    }
  }


  setStartDate(event: any) {
    $('.btn-with-tooltip').blur();
    event.jsdate ? this.datePickerModel.StartDate = event.jsdate : this.datePickerModel.StartDate = event
    this.dateChanged = true;
    this.setOptionsData();

    // Maintenance
    this.refreshView(new FilterModel(moment(this.datePickerModel.StartDate).format(environment.FULL_DATETIME_FORMAT), moment(this.datePickerModel.EndDate).format(environment.FULL_DATETIME_FORMAT)));
  }

  datePeriodChanged(event: any) {
    this.datePickerModel.EndDate = new Date();
    this.datePickerModel.EndDate.setMonth(this.datePickerModel.StartDate.getMonth());
    this.datePickerModel.EndDate.setFullYear(this.datePickerModel.StartDate.getFullYear());
    const dateRangeInterval = this.getDateRangeFilter(this.dateRangeFilters[event], this.datePickerModel.StartDate);
    this.datePickerModel.EndDate.setDate(this.datePickerModel.StartDate.getDate() + dateRangeInterval);
    this.setEndDate(this.datePickerModel.EndDate)
  }

  goForwardNumberOfDays(dateRangeFilterString: any, isForward: boolean) {
    const key = Object.keys(DateRangeFilter).filter(k => isNaN(Number(k))).find(k => k.toString() === dateRangeFilterString)
    let dateRangeFilter = this.dateRangeFilters[key];
    if (key === undefined) {
      dateRangeFilter = this.dateRangeFilters[0];
    }
    let days = this.getDateRangeFilter(dateRangeFilter, this.datePickerModel.StartDate);

    let dateInterval: [Date, Date];
    if (isForward) {
      dateInterval = this.goForward(days);
    } else {
      dateInterval = this.goBackwards(days);
    }

    this.datePickerModel.StartDate = dateInterval[0];
    this.datePickerModel.EndDate = dateInterval[1];

    this.dateChanged = true;
    this.setOptionsData();

    // Maintenance
    this.refreshView(new FilterModel(moment(this.datePickerModel.StartDate).format(environment.FULL_DATETIME_FORMAT), moment(this.datePickerModel.EndDate).format(environment.FULL_DATETIME_FORMAT)));
  }

  /**
   * Go a number of days forward.
   * @param days The number of days to go forward.
   * @returns The starting Monday and ending Sunday.
   */
  private goForward(days: number): [Date, Date] {
    var monday = this.datePickerModel.EndDate;
    monday = this.setDateToDay(monday, 1);

    const sunday: Date = this.getSundayFromDate(monday, days);

    return [monday, sunday];
  }

  /**
   * Go a number of days back.
   * @param days The number of days to go back.
   * @returns The starting Monday and ending Sunday.
   */
  private goBackwards(days: number): [Date, Date] {
    var monday = this.datePickerModel.StartDate;
    monday.setDate(monday.getDate() - days);
    monday = this.setDateToDay(monday, 1);

    const sunday: Date = this.getSundayFromDate(monday, days);

    return [monday, sunday];
  }

  /**
   * Gets the Sunday of the ending date.
   * @param date The date + a number of days to get the sunday of.
   * @param days The days forward of the date.
   * @returns The Sunday of the date.
   */
  private getSundayFromDate(date: Date, days: number): Date {
    var sunday = new Date(date);
    sunday.setDate(sunday.getDate() + days);
    sunday = this.setDateToDay(sunday, 0);
    return sunday;
  }

  getDateRangeFilter(dateRangeFilter: string, startDate: Date): number {
    switch (+dateRangeFilter) {
      case DateRangeFilter.Week:
        return 6;
      case DateRangeFilter.FourteenDays:
        return 13;
      case DateRangeFilter.Month:
        return this.getDaysInMonth(startDate.getFullYear(), startDate.getMonth());
      case DateRangeFilter.Quarter:
        return this.getDaysInQuarter(startDate.getFullYear(), startDate.getMonth());
      case DateRangeFilter.Year:
        return this.getDaysInYear(startDate.getFullYear(), startDate.getMonth());
      default:
        return 7;
    }
  }

  getDaysInMonth(year, month) {
    return new Date(year, month, 0).getDate();
  }

  getDaysInQuarter(year, startMonth) {
    return this.getDaysInMonth(year, startMonth) + this.getDaysInMonth(year, startMonth + 1) + this.getDaysInMonth(year, startMonth + 2)
  }

  getDaysInYear(year, startMonth) {
    return this.getDaysInQuarter(year, startMonth) + this.getDaysInQuarter(year, startMonth + 3) + this.getDaysInQuarter(year, startMonth + 6) + this.getDaysInQuarter(year, startMonth + 9)
  }


  setOptionsData() {
    this.setDuration();

    this.datePickerModel.dummyStart = {
      date: {
        year: this.datePickerModel.StartDate.getFullYear(),
        month: this.datePickerModel.StartDate.getMonth() + 1,
        day: this.datePickerModel.StartDate.getDate()
      }
    };
    this.datePickerModel.dummyEnd = {
      date: {
        year: this.datePickerModel.EndDate.getFullYear(),
        month: this.datePickerModel.EndDate.getMonth() + 1,
        day: this.datePickerModel.EndDate.getDate()
      }
    };


    this.datePickerModel.startDatePickerOptions = {
      // other options...
      dateFormat: 'dd/mm/yyyy',
      showWeekNumbers: true,
      showClearDateBtn: false,
      disableDateRanges: [{ begin: this.datePickerModel.dummyEnd.date, end: { year: 2055, month: 11, day: 20 } }],
    };
    this.datePickerModel.endDatePickerOptions = {
      // other options...
      dateFormat: 'dd/mm/yyyy',
      showWeekNumbers: true,
      showClearDateBtn: false,
      disableDateRanges: [{ begin: { year: 1980, month: 11, day: 20 }, end: this.datePickerModel.dummyStart.date }],
      alignSelectorRight: true,
    };

    
  }

  getTimeOfDate(date: Date): number {
    const s = moment(date).format(environment.START_DATETIME_FORMAT);
    const d = new Date(s);
    return d.getTime();
  }

  setDuration() {
    const diff = Math.abs(this.getTimeOfDate(this.datePickerModel.StartDate) - this.getTimeOfDate(this.datePickerModel.EndDate));

    this.duration = Math.ceil(diff / (1000 * 3600 * 24)) + 1;
  }

  ToggleShowStartEndDateOnTasks() {
    $('.btn-with-tooltip').blur();
    this.loading = true;
    this.toggleShowDatesOnResource(!this.showDatesOnResource);
  }


  toggleList(toggledList) {
    this.listToShow = toggledList;
  }

  getTask(task: Task){
    this.taskservice.getTask(task.Task_GUID, task.Company_Reference).subscribe(taskResult => {
      if (this.currentProductModel === productModels.Maintenance && taskResult && taskResult.Task_GUID) {
        this.activityService.getActivities(taskResult.Task_GUID).subscribe(activities => {
          taskResult.TaskActivities = activities;
          this.openModal(taskResult);
        }, () => {
          this.openModal(taskResult);
        });
        return;
      }

      this.openModal(taskResult);
    })
  }

  openModal(task: Task) {
    this.ChosenModal = ModalType.DetailTaskModal;
    setTimeout(() => {
      this.chosenTask = Object.assign({}, task);
      $('#myModal').modal('show');
    }, 5)
  }

  setCurrentLanguage(language) {
    this.currentLanguage = language;
    this.dateChanged = true;
  }

  setChosenJob() {
    if (this.config.chosenJob != null) {
      this.ChosenJob = this.config.chosenJob;
    } else {
      if (this.currentProductModel === productModels.Maintenance) {
        this.ChosenJob = { No: 'Alle' };
        this.ChosenJob.start = new Date().toISOString();
        this.ChosenJob.end = new Date().toISOString();
      }
    }
  }

  createNotification(notification: MaintenanceNotification) {
    this.ChosenModal = '';
    let company = notification.Company_Reference;
    notification.Company_Reference = null;
    
    const notificationSub = this.notificationService.Post(notification, company).subscribe(x => {
      this.refreshView();
      $('#createNotificationModal').modal('hide');
    }, error => {
    }, () => {
      notificationSub.unsubscribe()
    });
  }

  setSelectedFilter(field_name: string, field_value: string): boolean {
    const filterFields = this.externalFilter.FilterFields.filter(field => field.Field_Name.toUpperCase() == field_name.toUpperCase());
    let isChecked = false;
    for (const field of filterFields) {
      if (field_value.toUpperCase() === field.Field_Value.toUpperCase()) {
        isChecked = true;
      }
    }
    return isChecked;
  }

  fieldIsSelected(field_name: string, field_value: string) {
    const externalFilterField: ExternalFilterField = {
      SalesPerson_Code: this.externalFilter.SalesPersonCode,
      View_Name: this.externalFilter.ViewName,
      Field_Name: field_name,
      Field_Value: field_value
    };
    this.validateFilterField(externalFilterField);
  }

  closeSelector(id: string) {
    const checkboxes = document.getElementById(id);
    if (checkboxes) {
      checkboxes.style.display = 'none';
    }
  }

  showSpecificCheckBoxes(id: string) {
    const checkboxes = document.getElementById(id);
    if (!checkboxes) {
      return;
    }

    const isOpen = checkboxes.style.display === 'block';
    this.closeAllSelectors();
    checkboxes.style.display = isOpen ? 'none' : 'block';
  }

  closeAllSelectors() {
    const checkboxes = document.querySelectorAll('.checkboxes');
    for (let i = 0; i < checkboxes.length; i++) {
      const checkbox = checkboxes[i] as HTMLElement;
      checkbox.style.display = 'none';
    }
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (!target || !target.closest('.multiselect')) {
      this.closeAllSelectors();
    }
  }

  updateTaskActivities(taskActivities: TaskActivity[]) {
    const activitySub = this.activityService.putTaskActivities(taskActivities).subscribe(resp => {
      this.refreshView();
    }, error => {
    }, () => {
      activitySub.unsubscribe()
    });
  }

  setChosenResponsible(userNo: string) {
    this.chosenResponsible = this.responsibles.find(x => x.Code.toLowerCase().trim() == userNo.toLowerCase().trim());
  }

  setChosenCategory(category: number) {
    this.chosenCategory = this.AppTaskCategories.find(x => x.Entry_No == category);
  }

  //Count the number of occurances of properties in an array 
  countBy(arr, prop) {
    return arr.reduce((prev, curr) => (prev[curr[prop]] = ++prev[curr[prop]] || 1, prev), {});
  }

  refreshView(filterModel: FilterModel = null, isChangingView: boolean = false) {
    this.countByFilterProp = this.countBy(this.externalFilter.FilterFields, "Field_Name")
    this.validateStyles = true;
    this.loading = isChangingView;
    this.setChosenJob();
    this.cancelRefreshSubscriptions();

    if (this.ChosenJob != null) {

      let localGantchart = this.gantChart;

      if (localGantchart == null) {
        localGantchart = new GantChart();
        localGantchart.ExternalPaginatedTasks.PageIndex = 1;
      }

      if (filterModel != null) {
        localGantchart.FromDate = filterModel.FromDate;
        localGantchart.ToDate = filterModel.ToDate;
      }

      let taskPageModel: TaskPageModel = new TaskPageModel();
      if (this.currentProductModel == productModels.Maintenance) {
        taskPageModel.FromDate = localGantchart.FromDate;
        taskPageModel.ToDate = localGantchart.ToDate;
        taskPageModel.ExternalFilter = this.externalFilter;
      }
      this.externalSub = this.getExternalTasks(localGantchart.ExternalPaginatedTasks).subscribe(externalTasks => {
        localGantchart.ExternalPaginatedTasks = externalTasks;
        localGantchart.ExternalTasks = externalTasks.Tasks;

        this.allTasksSub = this.getAllTasks(taskPageModel).subscribe(allTasks => {
          localGantchart.JobTasks = this.setResources(allTasks.Tasks);
          this.tasks = allTasks.Tasks;
          this.placedSub = this.getPlacedTasks(taskPageModel).subscribe(placedTasks => {
            localGantchart.PlacedTasks = this.convertservice.convertTasksToPlacedTasks(placedTasks.Tasks, localGantchart.JobTasks);
            
            // NM 250221 - Chunk up sentence >>
            localGantchart.PlacedTasks.forEach(x => {
              let { chunks, characterLength } = this.convertservice.chunk(x.title, 25);
              x.title = chunks.join('\n');
            });
            // NM 250221 - Chunk up sentence <<
            if (this.currentProductModel == productModels.Premium) {
              localGantchart.PlacedTasks.push(this.convertservice.ConvertToVisualConstraint(this.ChosenJob.No, this.ChosenJob.start, this.ChosenJob.end));
            }
            this.gantChart = localGantchart;
            this.sortJobTasks();
            if (this.child != null) {
              this.child.rerenderCalendar(this.gantChart, true);
            }
            this.cancelRefreshSubscriptions();
            this.loading = false;
          });
        });
      });

     
    }
  }

  cancelRefreshSubscriptions() {
    if (this.externalSub) {
      this.externalSub.unsubscribe();
    }
    if (this.allTasksSub) {
      this.allTasksSub.unsubscribe();
    }
    if (this.placedSub) {
      this.placedSub.unsubscribe();
    }
  }

  getExternalTasks(taskPageModel: TaskPageModel): Observable<TaskPageModel> {
    taskPageModel.JobNo = this.ChosenJob.No;
    taskPageModel.FilterType = FilterTypes.External;

    return this.taskservice.getFilteredTasks(taskPageModel);
  }

  getPlacedTasks(taskPageModel: TaskPageModel): Observable<TaskPageModel> {
    taskPageModel.JobNo = this.ChosenJob.No;
    taskPageModel.FilterType = FilterTypes.Placed;

    if (this.currentProductModel == productModels.Premium) {
      return this.taskservice.getFilteredTasks(taskPageModel);
    } else if (this.currentProductModel == productModels.Maintenance) {
      // Filtered by date
      return this.eplannerTasksWithFilterService.getFilteredTasks(taskPageModel);
    }
  }

  getAllTasks(taskPageModel: TaskPageModel): Observable<TaskPageModel> {
    taskPageModel.JobNo = this.ChosenJob.No;
    taskPageModel.FilterType = FilterTypes.All;

    if (this.currentProductModel == productModels.Premium) {
      return this.taskservice.getFilteredTasks(taskPageModel);
    }
    if (this.currentProductModel == productModels.Maintenance) {
      // Filtered by date
      return this.eplannerTasksWithFilterService.getFilteredTasks(taskPageModel)
    }
  }

  ngOnDestroy() {
    if (this.subscription != null) {
      this.subscription.unsubscribe();
    }
    if (this.jobSubscription != null) {
      this.jobSubscription.unsubscribe();
    }
    this.setPageScrollLock(false);
  }

  private setPageScrollLock(locked: boolean) {
    const body = document.body;
    const html = document.documentElement;

    if (locked) {
      if (!this.pageScrollLocked) {
        this.lockedBodyOverflow = body.style.overflow;
        this.lockedHtmlOverflow = html.style.overflow;
        this.pageScrollLocked = true;
      }

      body.style.overflow = 'hidden';
      html.style.overflow = 'hidden';
      return;
    }

    if (!this.pageScrollLocked) {
      return;
    }

    body.style.overflow = this.lockedBodyOverflow;
    html.style.overflow = this.lockedHtmlOverflow;
    this.pageScrollLocked = false;
  }

  setResources(tasks) {
    let result = this.convertservice.convertTasksToResources(tasks, this.showDatesOnResource);

    // Break title in resource when sentence to long >>
    let resourceCharacterLength = 1;

    result.forEach(x => {
      let { chunks, characterLength } = this.convertservice.chunk(x.title, 25, resourceCharacterLength);
      resourceCharacterLength = characterLength;
      x.title = chunks.join('\n');
    });
    this.maxResourceNameLength = 13 + (resourceCharacterLength * 7);

    return result;
  }

  sortJobTasks() {
    this.gantChart.JobTasks.sort((n1, n2) =>
      this.sortDatetimes(n1.start, n2.start)
    );
  }

  sortDatetimes(n1: string, n2: string): number {
    let n1Time = new Date(n1).getTime();
    let n2Time = new Date(n2).getTime();

    if (moment(n1Time).format(environment.START_DATETIME_FORMAT) == environment.DEFAULT_DATETIME_START) {
      // set time from minus to plus - Sets the tasks last in the page instead of first.
      n1Time = Math.abs(n1Time);
    }

    if (moment(n2Time).format(environment.START_DATETIME_FORMAT) == environment.DEFAULT_DATETIME_START) {
      // set time from minus to plus - Sets the tasks last in the page instead of first.
      n2Time = Math.abs(n2Time);
    }

    return (n1Time - n2Time)
  }

  // Calls the service to save the updated task data, after converting the dateTime.
  updateTask(taskToUpdate: Task) {
    this.ChosenModal = '';
    this.taskservice.putTaskInfo(taskToUpdate, taskToUpdate.Company_Reference).subscribe();
  }

  /***
   * This method is called when a Task is updated from getting dropped inside the calendar.
   * @param task
   */
  updateTaskTime(taskToUpdate: Task) {
    this.taskservice.putTaskTime(this.convertservice.ConvertFromSchedulerDate(taskToUpdate, true), taskToUpdate.Company_Reference).subscribe();
  }

  /***
   * This method is called when a Task Activities is updated
   * @param activities
   */
  updateActivities(activities: TaskActivity[]) {
    const activitySub = this.activityService.putTaskActivities(activities).subscribe(resp => {
      this.refreshFilteredTasks(this.gantChart.ExternalPaginatedTasks);
    }, error => {
    }, () => {
      activitySub.unsubscribe()
    });
  }

  /***
   * This method is called when a Task is dropped from a external list.
   * @param task
   */
  applyTaskTime(taskToUpdate: Task) {
    this.taskservice.putTaskTime(taskToUpdate).subscribe(t => {
    });
  }

  refreshFilteredTasks(taskPageModel: TaskPageModel) {
    this.gantChart.ExternalPaginatedTasks = taskPageModel;
    // Maintenance
    this.refreshView();
  }

  updateOldJobTasks() {
    const self = this;
    this.gantChart.JobTasks.forEach(x => {
      let placedVersion = self.gantChart.PlacedTasks.filter(y => y.TaskRef == x.id);

      if (placedVersion.length > 0) {
        x.start = placedVersion[0].start;
        x.end = placedVersion[0].end;
      } else {
        x.start = '0001-01-01T00:50:20';
        x.end = '0001-01-01T00:50:20';
      }

      // NM 250320 >>
      if (this.showDatesOnResource) {
        let datestring = this.convertservice.DatesToString(x.start, x.end);
        x.title = x.JobTaskNo + ' - ' + x.Title + (datestring != '' ? ' - ' + datestring : '');
      }
      // NM 250320 >>

    })
  }

  resourceAreaResized(newWidth: any) {
    this.maxResourceNameLength = newWidth;
    this.child.rerenderCalendar(this.gantChart, true);
    let config: UIConfigSessionObject = this.sessionService.getUIConfigSessionObject();
    config.SSOResourceWidth = newWidth;
    this.sessionService.setUIConfigSession(config);
  }

  toggleShowDatesOnResource(newValue: boolean) {
    this.showDatesOnResource = newValue;
    this.refreshView();
  }

  changeChosenResponsible(ref: string) {
    this.setChosenResponsible(ref);
    this.refreshView();
  }

  changeChosenCategory(ref: number) {
    this.setChosenCategory(ref);
    this.refreshView();
  }

  GetAppTaskCategories() {
    this.notificationService.GetTaskCategories().subscribe(result => {
      if (result.length > 0) {
        this.AppTaskCategories = result;
      }
    })
  }

  changeChosenStatus(ref: any) {
    this.chosenStatus = ref;
    this.refreshView();
  }

  addFilterField(exFilterField: ExternalFilterField) {
    this.externalFilter.FilterFields.push(exFilterField);
    this.refreshView();
  }

  deleteFilterField(index: number) {
    this.externalFilter.FilterFields.splice(index, 1);
    this.refreshView();
  }

  validateFilterField(exFilterField: ExternalFilterField, filteredFromUrl: boolean = false) {
    let filterFields: ExternalFilterField[] = this.externalFilter.FilterFields.filter(field => field.Field_Name == exFilterField.Field_Name);
    let isInArray: boolean = false;
    if (this.externalFilter.FilterFields.length != 0) {
      for (let field of filterFields) {
        if (!isInArray) {
          if (exFilterField.Field_Value.toUpperCase() == field.Field_Value.toUpperCase()) {
            isInArray = true;
          }
        }
      }
    }

    if (isInArray && filteredFromUrl) {
      return;
    }

    if (!isInArray) {
      this.addFilterField(exFilterField);
    } else {
      const specificFilterField = filterFields.find(field => field.Field_Value.toUpperCase() == exFilterField.Field_Value.toUpperCase());
      const index = this.externalFilter.FilterFields.indexOf(specificFilterField);
      this.deleteFilterField(index);
    }
    this.refreshView();
  }

  clearField(field_name: string) {
    let fieldsToDelete = this.externalFilter.FilterFields.filter(field => field.Field_Name == field_name);
    for (let field of fieldsToDelete) {
      const index = this.externalFilter.FilterFields.indexOf(field);
      this.deleteFilterField(index);
    }
  }


  combineFilterValues(filters: ExternalFilterField[]): Map<string, string> {
    const map = this.combinedFilterValues;

    filters.forEach(filter => {
      if (map.has(filter.Field_Name)) {
        let value = map.get(filter.Field_Name)
        value += `|${filter.Field_Value}`;
        map.set(filter.Field_Name, value);
      } else {
        map.set(filter.Field_Name, filter.Field_Value)
      }
    })
    return map;
  }

  saveFilters() {
    this.loadingSaveButton = true;
    const filters = this.externalFilter.FilterFields;
    const user = this.loggedInSalesperson;
    this.combinedFilterValues.clear();

    const combinedFilterValues = this.combineFilterValues(filters);

    
    for (let key in FilterMapping) {
      if (user.hasOwnProperty(key)) {
        user[key] = combinedFilterValues.get(this.isSelectedCompanyOTS && key === 'App_Responsible_Filter' ? `OTS_${FilterMapping[key]}` : FilterMapping[key])
      }
    }
    for (let key in user) {
      if (!user[key]) {
        user[key] = ''
      }
    }

    const salesPersonSub = this.salesPersonService.updateSalesPerson(user).subscribe(resp => {
      if (resp) {
        this.refreshView(new FilterModel(moment(this.datePickerModel.StartDate).format(environment.FULL_DATETIME_FORMAT), moment(this.datePickerModel.EndDate).format(environment.FULL_DATETIME_FORMAT)))
        if (this.isMobileView()) {
          this.showMobileFilters = false;
        }
      }
    }, error => { }, () => { salesPersonSub.unsubscribe(), this.loadingSaveButton = false; })
  }

 setTranslations() {
    this.translationService.loadTranslations();
    this.translationService.translationsSub.subscribe(translations => {
      // Get translations from the service
      if (translations !== null && Object.keys(translations).length > 0) {
        // Check to make sure that translations is loaded and in the correct language
        this.translationService.getLanguageSubject().subscribe(language => {
          // This check is done to only set translationsLoaded if the language in the translation object matches the active language. Sometimes it returns the old language object as the first call
          if (language == translations[Object.keys(translations)[0]].Language_Code) {
            this.translationsLoaded = true
          }
        })
      }
    })
  }

  setExternalFilterFields() {
    this.externalFilter.FilterFields = this.convertservice.ConvertFilterValues(this.loggedInSalesperson);
  }



  clearFilters() {
    this.externalFilter.FilterFields = [];
    if (!this.isOTSTaskShown) {
      this.fieldIsSelected('TASKLEVEL', 'INTERN');
    }
    this.refreshView();
  }

}





// WEBPACK FOOTER //
// C:/Projects/ePlanner Maintenance/src/app/controllers/charts/gant-chart/gant-chart.component.ts